var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-layout"},[_c('el-container',{staticClass:"sidebar-holder"},[_c('el-container',{staticClass:"main-content"},[_c('the-header'),_c('el-main',{staticClass:"main-body-container"},[_c('survey-banner'),_c('router-view')],1)],1)],1),_c('the-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }